function getFileType(url, fileType) {
  let fileExtension = url.split('.');
  fileExtension = fileExtension[fileExtension.length - 1].toLowerCase();

  const getType = (ext) => {
    if (/^(jpe?g|png|gif|avif|svg|tif?f|bmp|webp|ico)$/i.test(ext) || fileType.includes('image/')) {
      return 'image';
    }

    if (/^(mp4|mpeg|webm|mkv|mov)$/i.test(ext) || fileType.includes('video/')) {
      return 'video';
    }

    if (/^(mp3|wav|ogg)$/i.test(ext) || fileType.includes('audio/')) {
      return 'audio';
    }

    if (/^pdf$/i.test(ext) || fileType.includes('pdf')) {
      return 'pdf';
    }

    if (
      /^xlsx?|csv$/i.test(ext) ||
      [
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'text/csv'
      ].some((f) => fileType.includes(f))
    ) {
      return 'excel';
    }

    if (
      /^docx?$/i.test(ext) ||
      [
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      ].some((f) => fileType.includes(f))
    ) {
      return 'word';
    }

    if (
      /^(zip|gz|7z)$/i.test(ext) ||
      [
        'application/vnd.rar',
        'application/x-7z-compressed',
        'application/zip',
        'application/x-zip-compressed',
        'application/zip-compressed',
        'application/gzip',
        'application/x-gzip'
      ].some((f) => fileType.includes(f))
    ) {
      return 'zip';
    }

    return 'unknown';
  };

  return { extension: fileExtension, type: getType(fileExtension) };
}

const defaultAcceptedFiles = {
  'image/*': [],
  'audio/*': [],

  'audio/acc': [],
  'audio/mpeg': [],
  'audio/ogg': [],
  'audio/opus': [],
  'audio/wav': [],
  'audio/webm': [],
  'audio/3gpp': [],
  'audio/3gpp2': [],

  'video/*': [],

  'application/msword': [],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [],

  'application/vnd.ms-excel': [],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [],
  'text/csv': [],

  'application/pdf': [],
  'application/x-pdf': [],

  'application/vnd.rar': [],
  'application/x-7z-compressed': [],
  'application/zip': [],
  'application/x-zip-compressed': [],
  'application/zip-compressed': [],
  'application/gzip': [],
  'application/x-gzip': []
};

export { getFileType, defaultAcceptedFiles };
